import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@/lib/queryClient';
import type { HomeGame } from '@/types/game';
import { useAuth } from '@/hooks/use-auth';

export function useVideoProgress(game?: HomeGame, showVideo = false) {
  const { user } = useAuth();

  const {
    data: progressData,
    isLoading,
    error,
  } = useQuery<{ progressSeconds: number }>({
    queryKey: [
      '/api/videos/progress?' +
        new URLSearchParams({
          gameId: String(game?.id),
          videoId: String(game?.videoId),
        }),
    ],
    queryFn: fetcher,
    enabled: !!game?.id && !!user && !showVideo,
  });

  return { progressData, isLoading, error };
}
